import axios from 'axios';

/**
 * Parse the content-range header.
 *
 * @param {String} str
 * @returns {Object}
 */
function parseRange(str) {
    let matches;

    if (typeof str !== "string") return null;

    if (matches = str.match(/^(\w+) (\d+)-(\d+)\/(\d+|\*)/)) return {
        unit: matches[1],
        first: +matches[2],
        last: +matches[3],
        length: matches[4] === '*' ? null : +matches[4]
    };

    if (matches = str.match(/^(\w+) \*\/(\d+|\*)/)) return {
        unit: matches[1],
        first: null,
        last: null,
        length: matches[2] === '*' ? null : +matches[2]
    };

    return null;
}

export class ApiClient {
    searchSubtitles(searchQuery, start, end) {
        return axios.get('/api/subtitles?q=' + searchQuery, {
            headers: { "Range": "resources=" + start + "-" + end }
        }).then(response => ({
            data: response.data,
            range: parseRange(response.headers['content-range'])
        }));
    }
}


// WEBPACK FOOTER //
// ../clients/ApiClient.js